import { useSelector, useDispatch, useStore } from "react-redux"
import type { ReduxState } from "model/state"
import type { AppDispatch, AppStore } from "../../store"

export const useAppSelector = useSelector.withTypes<ReduxState>()
export const useAppDispatch = useDispatch.withTypes<AppDispatch>()
// Typed store accessor for reading FRESH state inside callbacks/effects (store.getState()),
// where a useAppSelector closure would be stale. Never read getState() during render.
export const useAppStore = useStore.withTypes<AppStore>()
